// 設定用データ
// 将来的にサーバからデータが来ると想定して user/account/theme.blade.php に定義を移動しました。
export const SETTING_DATA = {
  theme: {
    items: [
      { label: '恋愛', value: '恋愛', category: '1' },
      { label: '結婚', value: '結婚', category: '1' },
      { label: '相性', value: '相性', category: '1' },
      { label: '出会い', value: '出会い', category: '1' },
      { label: '仕事', value: '仕事', category: '2' },
      { label: '転職', value: '転職', category: '2' },
      { label: 'お金', value: 'お金', category: '2' },
      { label: 'あの人のこと', value: 'あの人の\nこと', category: '1' },
      { label: '自分のこと', value: '自分の\nこと', category: '2' },
      { label: '運命', value: '運命', category: '2' },
      { label: '未来', value: '未来', category: '1' },
      { label: '転機', value: '転機', category: '2' }
    ]
  },
  worried: {
    '1': {
      items: [
        { label: 'worried1_1', value: `私の魅力` },
        { label: 'worried1_2', value: `恋愛グセ` },
        { label: 'worried1_3', value: `運命の人` },
        { label: 'worried1_4', value: `恋がしたい` },
        { label: 'worried1_5', value: `モテたい` },
        { label: 'worried1_6', value: `出会い待ち` },
        { label: 'worried1_7', value: `片思い` },
        { label: 'worried1_8', value: `あやふやな\n関係` },
        { label: 'worried1_9', value: `相手の本音` },
        { label: 'worried1_10', value: `二人の未来` },
        { label: 'worried1_11', value: `相性` },
        { label: 'worried1_12', value: `結婚` }
      ]
    },
    '2': {
      items: [
        { label: 'worried2_1', value: `性格診断` },
        { label: 'worried2_2', value: `全体運` },
        { label: 'worried2_3', value: `生き方` },
        { label: 'worried2_4', value: `天職` },
        { label: 'worried2_5', value: `才能・適職` },
        { label: 'worried2_6', value: `独立・起業` },
        { label: 'worried2_7', value: `出世` },
        { label: 'worried2_8', value: `昇給` },
        { label: 'worried2_9', value: `仕事相性` },
        { label: 'worried2_10', value: `一攫千金` },
        { label: 'worried2_11', value: `家族のこと` },
        { label: 'worried2_12', value: `子供のこと` }
      ]
    },
    '3': {
      items: [{ label: 'worried3_1', value: `3-1` }, { label: 'worried3_2', value: `3-2` }]
    },
    '4': {
      items: [{ label: 'worried4_1', value: `4-1` }, { label: 'worried4_2', value: `4-2` }]
    }
  },
  fortune: [
    { label: '西洋占星術', value: `西洋占星術` },
    { label: 'タロット', value: `タロット` },
    { label: '風水', value: `風水` },
    { label: '手相', value: `手相` },
    { label: '四柱推命', value: `四柱推命` },
    { label: '霊視', value: `霊視` },
    { label: '姓名判断', value: `姓名判断` },
    { label: '生年月日なしでも占える', value: `生年月日\nなしでも\n占える` },
    { label: '東洋占星術', value: `東洋占星術` },
    { label: 'ルーン', value: `ルーン` },
    { label: 'チャット占い', value: `チャット占い` },
    { label: '対面鑑定', value: `対面鑑定` }
  ],
  teller: [
    { label: '鏡リュウジ', value: `鏡リュウジ` },
    { label: '島田秀平', value: `島田秀平` },
    { label: '水晶玉子', value: `水晶玉子` },
    { label: '木村藤子', value: `木村藤子` },
    { label: 'イヴルルド遥華', value: `イヴルルド\n遥華` },
    { label: '上地一美', value: `上地一美` },
    { label: 'ゲッターズ飯田', value: `ゲッターズ\n飯田` },
    { label: 'マドモアゼル愛', value: `マドモアゼル\n愛` },
    { label: '安斎勝洋', value: `安斎勝洋` },
    { label: 'しいたけ', value: `しいたけ` },
    { label: '石井ゆかり', value: `石井ゆかり` },
    { label: '原宿の母', value: `原宿の母` }
  ]
}

const BASE_PATH = '/static/img/toppage/lp/'
export const TAGS_DATA = {
  // 占い師タグ
  id403: { id: 403, tag_label: 'マドモアゼル・愛', display_label: 'マドモアゼル愛', img: `${BASE_PATH}tag403.png` },
  id404: { id: 404, tag_label: 'イリヤ', display_label: 'イリヤ', img: `${BASE_PATH}tag404.png` },
  id405: { id: 405, tag_label: 'ステラ薫子', display_label: 'ステラ薫子', img: `${BASE_PATH}tag405.png` },
  id407: { id: 407, tag_label: 'パシンペロンはやぶさ', display_label: 'パシンペロン<br>はやぶさ', img: `${BASE_PATH}tag407.png` },
  id412: { id: 412, tag_label: '濱口善幸', display_label: '濱口善幸', img: `${BASE_PATH}tag412.png` },
  id424: { id: 424, tag_label: '水晶玉子', display_label: '水晶玉子', img: `${BASE_PATH}tag424.png` },

  // 通常タグ
  id1002: { id: 1002, tag_label: '今日の運勢', display_label: '今日の運勢' },
  id1007: { id: 1007, tag_label: '片思い', display_label: '片思い' },
  id1011: { id: 1011, tag_label: '復活待ち', display_label: '復活待ち' },
  id1014: { id: 1014, tag_label: '相性', display_label: '相性' },
  id1015: { id: 1015, tag_label: '相手の本音', display_label: '相手の本音' },
  id1016: { id: 1016, tag_label: '不倫', display_label: '不倫' },
  id1018: { id: 1018, tag_label: 'モテたい', display_label: 'モテたい' },
  id1021: { id: 1021, tag_label: '人間関係', display_label: '人間関係' },
  id1022: { id: 1022, tag_label: '性格診断', display_label: '性格診断' },
  id1038: { id: 1038, tag_label: '恋のチャンス', display_label: '恋のチャンス' },
  id1042: { id: 1042, tag_label: '2人の未来', display_label: '２人の未来' },
  id1043: { id: 1043, tag_label: '付き合いたい', display_label: '付き合いたい' },
  id1044: { id: 1044, tag_label: '恋がしたい', display_label: '恋がしたい' },
  id1047: { id: 1047, tag_label: '愛されたい', display_label: '愛されたい' },
  id1050: { id: 1050, tag_label: '彼との結婚', display_label: '彼との結婚' },
}

const _NON_MEMBER_LP = {
  additionalCounselors: [
    'id403',
    'id404',
    'id424',
    'id405',
    'id407',
    'id412',
  ],
  tagCloud: [
    'id1043',
    'id1002',
    'id1018',
    'id1050',
    'id1015',
    'id1016',
    'id1022',
    'id1011',
    'id1042',
    'id1038',
    'id1044',
    'id1047',
    'id1007',
    'id1021',
    'id1014',
  ],
}

export class TagInfo {
  static nonMemberLp(target) {
    if (target in _NON_MEMBER_LP) {
      return _NON_MEMBER_LP[target].map(item => TAGS_DATA[item])
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/SUBSCRIPTION.js